import axios from 'axios'

import { apiUrlEnvUtils } from '../../utils/api-url-env.utils'

const VEHICLE_API_URL = apiUrlEnvUtils('REACT_APP_VEHICLE_API_URL')

/**
 * Get Inventory Vehicle VDP by vehicleId
 * @param { Object } object - The default payload
 * @param { String | Number } object.vehicleId - vehicleId
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { String } object.lang - Language
 * @return {Promise<{}>}
 */
export const getInventoryVehicleVdp = async ({ vehicleId, location, orgId, orgUnitId, lang }) => {
    const apiUrl = `${VEHICLE_API_URL}/inventory/vehicle/vdp/${vehicleId}?location=${location}&organizationId=${orgId}&organizationUnitId=${orgUnitId}&includeMetadata=true`

    const headers = {
        headers: {
            'Accept-Language': `${lang}-CA`,
        },
    }

    return await axios.post(apiUrl, {}, headers)
}

/**
 * Get Catalog Vehicle VDP by newCarTrimId
 * @param { Object } object - The default payload
 * @param { String | Number } object.newCarTrimId - newCarTrimId
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { String } object.lang - Language
 * @return {Promise<{}>}
 */
export const getCatalogVdp = async ({ newCarTrimId, location, orgId, orgUnitId, lang }) => {
    const apiUrl = `${VEHICLE_API_URL}/catalog/vdp/${newCarTrimId}?location=${location}&organizationId=${orgId}&organizationUnitId=${orgUnitId}`

    const headers = {
        headers: {
            'Accept-Language': `${lang}-CA`,
        },
    }

    return await axios.post(apiUrl, {}, headers)
}
